export const HOOK_API_VERSION = 'v2025-08-04'
